import React from 'react';
import { Home, List, X, Building, Users } from 'lucide-react';
interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  activePage: 'dashboard' | 'action-log' | 'all-sites' | 'all-guards';
  onNavigate: (page: 'dashboard' | 'action-log' | 'all-sites' | 'all-guards') => void;
}
export function Sidebar({
  isOpen,
  onClose,
  activePage,
  onNavigate
}: SidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: Home
  }, {
    id: 'all-sites',
    label: 'All Sites',
    icon: Building
  }, {
    id: 'action-log',
    label: 'Action Log',
    icon: List
  }, {
    id: 'all-guards',
    label: 'All Guards',
    icon: Users
  }] as const;
  return <>
      {/* Mobile Overlay */}
      {isOpen && <div className="fixed inset-0 z-40 bg-black/50 md:hidden" onClick={onClose} aria-hidden="true" data-id="element-1050" />}

      {/* Sidebar Container */}
      <aside className={`
          fixed inset-y-0 left-0 z-50 w-64 transform bg-[#062133] text-[#fff7ec] transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          md:translate-x-0 md:static md:inset-auto md:flex md:flex-col
        `} data-id="element-1051">
        {/* Logo / Brand Area */}
        <div className="flex h-16 items-center justify-between px-6 border-b border-[#1a3b4f]" data-id="element-1052">
          <div className="flex items-center gap-2.5 font-bold text-lg tracking-tight" data-id="element-1053">
            <img src="https://cdn.magicpatterns.com/uploads/jCJC46awojDwi4ekzzWFGE/jemx-logo.svg" alt="jemX" className="h-8 object-contain" data-id="element-1054" />
          </div>
          <button onClick={onClose} className="md:hidden text-[#fff7ec] hover:text-[#ff697f]" aria-label="Close sidebar" data-id="element-1055">
            <X size={24} data-id="element-1056" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-6 px-3" data-id="element-1057">
          <ul className="space-y-1" data-id="element-1058">
            {navItems.map(item => {
            const isActive = activePage === item.id;
            return <li key={item.id} data-id="element-1059">
                  <button onClick={() => {
                onNavigate(item.id);
                onClose(); // Close sidebar on mobile when navigating
              }} className={`
                      flex w-full items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors
                      ${isActive ? 'bg-[#ff697f] text-white shadow-md' : 'text-[#d1dde3] hover:bg-[#1a3b4f] hover:text-white'}
                    `} data-id="element-1060">
                    <item.icon size={20} data-id="element-1061" />
                    {item.label}
                  </button>
                </li>;
          })}
          </ul>
        </nav>

        {/* Footer / User Profile Summary could go here */}
        <div className="p-4 border-t border-[#1a3b4f]" data-id="element-1062">
          <div className="flex items-center gap-3 rounded-lg bg-[#1a3b4f]/50 p-3" data-id="element-1063">
            <div className="h-8 w-8 rounded-full bg-[#5a7280] flex items-center justify-center text-xs font-bold text-white" data-id="element-1064">
              JD
            </div>
            <div className="overflow-hidden" data-id="element-1065">
              <p className="truncate text-sm font-medium text-white" data-id="element-1066">
                John Doe
              </p>
              <p className="truncate text-xs text-[#d1dde3]" data-id="element-1067">
                Security Manager
              </p>
            </div>
          </div>
        </div>
      </aside>
    </>;
}